import firebase, { db, storage } from "config/firebase";
import { toast } from "react-toastify";

export const fetchOffers = (restaurantId) => (dispatch) => {
  dispatch({ type: "FETCH_OFFERS_REQUEST" });

  try {
    return db
      .collection("offers")
      .where("restaurantID", "==", restaurantId)
      .orderBy("createdAt", "desc")
      .onSnapshot(
        (snapshot) => {
          const offers = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          dispatch({
            type: "FETCH_OFFERS_SUCCESS",
            payload: offers,
          });
        },
        (error) => {
          console.error("Error fetching offers: " + error.message);
          toast.error("Error fetching offers: " + error.message);
          dispatch({
            type: "FETCH_OFFERS_ERROR",
            payload: error.message,
          });
        }
      );
  } catch (err) {
    console.error("Error fetching offers: " + err.message);
    toast.error("Error fetching offers: " + err.message);
    dispatch({ type: "FETCH_OFFERS_ERROR", payload: err.message });
  }
};

export const addOffer =
  (restaurantId, data, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      const { title, price, image, items } = data;
      dispatch({ type: "ADD_OFFER_REQUEST" });
      const docRef = db.collection("offers").doc();
      const offerId = docRef.id;
      const payload = {
        title,
        price,
        items,
        image: "",
        createdAt: firebase.firestore.Timestamp.now(),
        restaurantID: restaurantId,
      };

      const imageRef = storage.ref().child(`offers/${offerId}/${image.name}`);
      await imageRef.put(image);
      const imageUrl = await imageRef.getDownloadURL();
      payload.image = imageUrl;

      await docRef.set(payload);

      toast.success("Offer added successfully");

      dispatch({
        type: "ADD_OFFER_SUCCESS",
        payload,
      });
      onSuccess();
    } catch (err) {
      console.error("Failed to add offer: " + err.message);
      toast.error("Failed to add offer: " + err.message);
      dispatch({ type: "ADD_OFFER_ERROR", payload: err.message });
    }
  };

export const deleteOffer = (offerId, imageUrl) => async (dispatch) => {
  dispatch({ type: "DELETE_OFFER_REQUEST" });

  try {
    await db.collection("offers").doc(offerId).delete();

    const imageRef = storage.refFromURL(imageUrl);
    await imageRef.delete();

    toast.success("Offer deleted successfully");

    dispatch({ type: "DELETE_OFFER_SUCCESS" });
  } catch (err) {
    console.error("Failed to delete offer: " + err.message);
    toast.error("Failed to delete offer: " + err.message);
    dispatch({ type: "DELETE_OFFER_ERROR", payload: err.message });
  }
};

export const updateOffer =
  (offerId, data, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      const { title, price, image, items } = data;

      dispatch({ type: "UPDATE_OFFER_REQUEST" });

      const offerRef = db.collection("offers").doc(offerId);

      let updatePayload = {
        title,
        price,
        items,
        updatedAt: firebase.firestore.Timestamp.now(),
        image,
      };

      if (typeof image !== "string") {
        const imageRef = storage.ref().child(`offers/${offerId}/${image.name}`);
        await imageRef.put(image);
        const imageUrl = await imageRef.getDownloadURL();
        updatePayload.image = imageUrl;
      }

      await offerRef.update(updatePayload);

      toast.success("Offer updated successfully");

      dispatch({
        type: "UPDATE_OFFER_SUCCESS",
        payload: { ...updatePayload, id: offerId },
      });
      onSuccess();
    } catch (err) {
      console.error("Failed to update offer: " + err.message);
      toast.error("Failed to update offer: " + err.message);
      dispatch({ type: "UPDATE_OFFER_ERROR", payload: err.message });
    }
  };

export const checkItemPresent = (restaurantId) => (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = await db
        .collection("items")
        .where("restaurantID", "==", restaurantId)
        .limit(1)
        .get();

      const items = snapshot.docs.map((doc) => doc.exists);
      resolve(...items);
    } catch (error) {
      console.error("Failed to fetch items");
      reject(error);
    }
  });
};

export const fetchItems = (restaurantID) => (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const itemsSnapshot = await db
        .collection("items")
        .where("restaurantID", "==", restaurantID)
        .get();
      const items = itemsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      dispatch({
        type: "FETCH_ITEMS",
        payload: items,
      });
      resolve(items);
    } catch (error) {
      console.error(error.message);
      reject(error);
    }
  });
};

export const fetchLabels = (restaurantID) => (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const labelsSnapshot = await db
        .collection("labels")
        .where("restaurantID", "in", [restaurantID, "null"])
        .get();
      const labels = labelsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      dispatch({
        type: "FETCH_LABELS",
        payload: labels,
      });
      resolve(labels);
    } catch (error) {
      console.error(error.message);
      reject(error);
    }
  });
};
